import api from "@/router/api"

export default {
    getAllClientTypes({commit}, payload){
        return new Promise((resolve, reject) => {
            api.auxiliariesClientType.list(payload)
            .then(response => {
                resolve(response.data.data)
                commit('SET_CLIENT_TYPES', response.data.data.data)
            })
            .catch(error => {
                reject({
                    message: 'Ocurrió un problema al obtener los tipos de cliente',
                })
            })
        })
    },
    searchClientTypes({commit}, payload){
        return new Promise((resolve, reject) => {
            api.auxiliariesClientType.search(payload)
                .then(response => {
                    resolve(response.data.data)
                    commit('SET_CLIENT_TYPES', response.data.data.data)
                })
                .catch(error => {
                    reject({
                        message: 'Ocurrió un problema al obtener los niveles 2',
                    })
                })
        })
    },
    findClientTypes({commit}, payload){

        return new Promise((resolve, reject) => {
            api.auxiliariesClientType.find(payload)
                .then(response => {
                    resolve(response.data.data)
                    commit('SET_CLIENT_TYPE', response.data.data)
                })
                .catch(error => {
                    reject({
                        message: 'Ocurrió un problema al obtener el tipo de cliente',
                    })
                })
        })
    },
    createClientTypes({commit}, payload){
        commit('CLEAR_VALIDATION')
        return new Promise((resolve, reject) => {
            api.auxiliariesClientType.create(payload)
                .then(response => {
                    const {data} = response.data
                    commit('SET_CLIENT_TYPES', response.data.data)
                    resolve(data)
                })
                .catch(error => {
                    const { data, status} = error.response
                    const { message: title } = data

                    if(status === 422){
                        commit('SET_VALIDATION_ERRORS', data.errors)
                    }
                    reject({title, status})
                })
        })
    },
    updateClientTypes({commit}, payload){
        commit('CLEAR_VALIDATION')
        return new Promise((resolve, reject) => {
            api.auxiliariesClientType.update(payload)
                .then(response => {
                    const {data} = response.data

                    resolve(data)
                })
                .catch(error => {
                    const { data, status} = error.response
                    const { message: title } = data

                    if(status === 422){
                        commit('SET_VALIDATION_ERRORS', data.errors)
                    }
                    reject({title, status})
                })
        })
    },
    deleteClientTypes({commit}, payload) {
        return new Promise((resolve, reject) => {
            api.auxiliariesClientType.delete(payload.id)
                .then(response => {
                    const {data} = response.data

                    resolve(data)
                })
                .catch(() => {
                    reject({
                        message: 'Error al eliminar el tipo de cliente.',
                    })
                })
        })
    },
}
